import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Flip, toast, Zoom } from "react-toastify";
import { getResourcesList, putResource, registerResource } from "../api/resourcesAPI";

export const getResources = createAsyncThunk("resources/getResources", async (payload, { rejectWithValue }) => {
  try {
    const response = await getResourcesList(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Errorrrrrrrrr ", error);
    return rejectWithValue(error.message);
  }
});

export const addResource = createAsyncThunk("resources/addResource", async (payload, { rejectWithValue }) => {
  try {
    const response = await registerResource(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});


export const updateResource = createAsyncThunk("resources/updateResource", async (payload, { rejectWithValue }) => {
  try {
    const response = await putResource(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});


export const resourcesSlice = createSlice({
  name: "resources",
  initialState: {
    payload: {
      status: null,
      error: null,
      data: null,
    },
    post: {
      status: null,
      error: null,
      data: null,
    },
    put: {
      status: null,
      error: null,
      data: null,
    },
    get: {
      status: null,
      error: null,
      list: [],
    },
  },

  extraReducers: {
    [getResources.pending]: (state) => {
      state.get.status = "loading";
    },
    [getResources.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 200) {
        state.get.list = data;
        state.get.error = null;
      }else{
        state.get.error = { message: `${status} - An error occurred` };
        toast.error("System error couldn't get resources!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.get.status = 'idle';
    },
    [getResources.rejected]: (state, action) => {
      state.get.status = "idle";
      state.get.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't get resource!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    [addResource.pending]: (state) => {
      state.post.status = "loading";
    },
    [addResource.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 201) {
        toast.success("Resource saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
        state.post.status = "idle";
        state.post.error = null;
      }else{
        toast.warn("Couldn't add Resource!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
        state.post.error = "Failed";
      }

      state.post.data = data;
    },
    [addResource.rejected]: (state, action) => {
      //state.post.status = "idle";
      state.post.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't add resource!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    [updateResource.pending]: (state) => {
      state.put.status = "loading";
    },
    [updateResource.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 202) {
        toast.success("Resource saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
        state.put.status = "idle";
      }else{
        state.put.error = "Failed";
        toast.warn("Couldn't update resource!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.put.data = data;
    },
    [updateResource.rejected]: (state, action) => {
      state.put.status = "idle";
      state.put.error = { message: "An error occurred" };
      console.log("***** ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't add resource!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
  },
});

export default resourcesSlice.reducer;
